import { RouteComponent, RouteRecordRaw } from 'vue-router';
import { DASHBOARD_SECTIONS_ROUTES } from '@/models/common/permissions.model';
import { DASHBOARD_META_TITLES } from '@/models/common/meta-titles.model';

export const payoutOrderRoutes: RouteRecordRaw[] = [
  {
    name: DASHBOARD_SECTIONS_ROUTES.PAYOUT_ORDER,
    path: DASHBOARD_SECTIONS_ROUTES.PAYOUT_ORDER,
    meta: { title: DASHBOARD_META_TITLES.PAYOUT_ORDER_PAGE },
    component: async (): Promise<RouteComponent> =>
      await import('@/layouts/payout-order-page/payout-order-page.vue'),
  },
];
